import { createFileRoute } from '@tanstack/react-router'
import { CRT_ROUTES, toStaticData } from '../../crt-route-config'

export const Route = createFileRoute(
  '/_auth/_modules/crt/volume-forecasts/sub-channel-allocations',
)({
  staticData: toStaticData(CRT_ROUTES['/crt/volume-forecasts/sub-channel-allocations']),
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
